import createIcon from '@/lib/create-icon'
import React from 'react'

export const MoreSVGIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00033 8.66665C8.36852 8.66665 8.66699 8.36817 8.66699 7.99998C8.66699 7.63179 8.36852 7.33331 8.00033 7.33331C7.63214 7.33331 7.33366 7.63179 7.33366 7.99998C7.33366 8.36817 7.63214 8.66665 8.00033 8.66665Z"
      fill="currentColor"
    />
    <path
      d="M12.667 8.66665C13.0352 8.66665 13.3337 8.36817 13.3337 7.99998C13.3337 7.63179 13.0352 7.33331 12.667 7.33331C12.2988 7.33331 12.0003 7.63179 12.0003 7.99998C12.0003 8.36817 12.2988 8.66665 12.667 8.66665Z"
      fill="currentColor"
    />
    <path
      d="M3.33366 8.66665C3.70185 8.66665 4.00033 8.36817 4.00033 7.99998C4.00033 7.63179 3.70185 7.33331 3.33366 7.33331C2.96547 7.33331 2.66699 7.63179 2.66699 7.99998C2.66699 8.36817 2.96547 8.66665 3.33366 8.66665Z"
      fill="currentColor"
    />
    <path
      d="M8.00033 8.66665C8.36852 8.66665 8.66699 8.36817 8.66699 7.99998C8.66699 7.63179 8.36852 7.33331 8.00033 7.33331C7.63214 7.33331 7.33366 7.63179 7.33366 7.99998C7.33366 8.36817 7.63214 8.66665 8.00033 8.66665Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.667 8.66665C13.0352 8.66665 13.3337 8.36817 13.3337 7.99998C13.3337 7.63179 13.0352 7.33331 12.667 7.33331C12.2988 7.33331 12.0003 7.63179 12.0003 7.99998C12.0003 8.36817 12.2988 8.66665 12.667 8.66665Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33366 8.66665C3.70185 8.66665 4.00033 8.36817 4.00033 7.99998C4.00033 7.63179 3.70185 7.33331 3.33366 7.33331C2.96547 7.33331 2.66699 7.63179 2.66699 7.99998C2.66699 8.36817 2.96547 8.66665 3.33366 8.66665Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
